import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sort: 'newest',
  board: '',
  user: '',
  search: '',
  tag: ''
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setSort: (state, action) => {
      state.sort = action.payload;
    },
    setBoard: (state, action) => {
      state.board = action.payload;
    },
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setTag: (state, action) => {
      state.tag = action.payload;
    },
    resetFilters: (state) => {
      state.sort = 'newest';
      state.board = '';
      state.user = '';
      state.search = '';
      state.tag = '';
    }
  }
});

export const {
  setSort,
  setBoard,
  setUser,
  setSearch,
  setTag,
  resetFilters
} = filtersSlice.actions;

export const selectFilters = (state) => state.filters;

export default filtersSlice.reducer;
